<template>
  <mrc_ess_skeleton_loader :loading="skLoading">
    <div class="add_func_btn">
      <mrc_ess_iconGroup
        style="top: -50px"
        v-show="!disabled"
        v-if="$store.state.uuid"
        @handleReturn="handleReturn"
        :showEdit="hasBtn('edit-button')"
        @handleEdit="handleEdit"
        :show_del="false"
      ></mrc_ess_iconGroup>
      <v-card>
        <v-card-text class="tableBoxComponent">
          <v-data-table
            :items-per-page="100"
            :headers="header"
            :items="desserts"
            class="elevation-0"
            style="border: 1px solid rgba(0, 0, 0, 0.15)"
            hide-default-footer
          >
            <template v-slot:no-data>
              <mrc_ess_noContent :no_data_text="$t('label_blank')" />
            </template>

            <template v-slot:[`item.button_type`]="{ item }">
              {{ INT(btnTypeToName(item.button_type)) }}
            </template>

            <template v-slot:item.button_title="{ item }">
              {{ INT(item.button_title) }}
            </template>
            <template v-slot:item.status_uuid="{ item }">
              <mrc_ess_viewbtn :is_used="item.status_uuid"></mrc_ess_viewbtn>
            </template>
            <template v-slot:item.actions="{ item }">
              <!-- <v-btn v-show="!disabled"
                     icon
                     elevation="0"
                     @click="changeItem(item, true)">
                <i class="material-icons">remove_red_eye</i>
              </v-btn> -->
              <mrc_ess_svgIcon
                v-if="!disabled"
                iconClass="view_detail"
                @click.native="changeItem(item, true)"
                style="font-size: 23px"
              />
              <v-btn
                v-show="disabled"
                elevation="0"
                icon
                @click.stop="changeItem(item, false)"
              >
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
              <v-btn
                v-show="disabled"
                icon
                elevation="0"
                @click.stop="delItem(item)"
                v-if="hasBtn('delete-button')"
              >
                <v-icon>mdi-delete</v-icon>
              </v-btn>

              <!-- <v-icon v-show="item.uuid" @click.stop="upItem(item)"
                >mdi-sort-descending</v-icon
              > -->
            </template>
          </v-data-table>
          <v-dialog
            v-model="dialog"
            :width="dialogWidth"
            scrollable
            :persistent="!onlyShow"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                text
                v-bind="attrs"
                v-on="on"
                v-show="disabled"
                color="primary"
                @click="open_btn_dialog"
                class="mt-2 text-lowercase"
              >
                <span style="cursor: pointer">{{
                  $t("label_Add_a_button")
                }}</span>
                <i style="cursor: pointer" class="material-icons">add</i>
              </v-btn>
            </template>
            <!-- :func_version='version_uuid_' -->
            <!-- :version_uuid123='version_uuid123' -->
            <add-dialog
              v-if="dialog"
              :dialogWidth="dialogWidth"
              @getBtnDetail="getBtnDetail"
              @cancel="dialogClose"
              :client_type="client_type"
              :btnFunc="btnFunc"
              :dialogTitle="dialogTitle"
              :btnType="btnType"
              :version_arr="version_arr"
              :version_uuid="func_version"
              :dialogDefaultData="dialogDefaultData"
              @addBtnIcon="addBtnIcon"
              :onlyShow="onlyShow"
              :update_add="update_add"
              :module_uuid="module_uuid"
            ></add-dialog>
          </v-dialog>
        </v-card-text>

        <mrc_ess_submitBtn
          v-show="disabled"
          :loading="submitLoading"
          @cancel="cancel"
          @success="success"
        ></mrc_ess_submitBtn>
      </v-card>
    </div>
  </mrc_ess_skeleton_loader>
</template>

<script>
import addDialog from "./add_btn_dialog";
import { getDataByName } from "@/service/api/data_dictionary";
import { getBusinessList } from "@/service/api/prompt";
import {
  get_versions,
  up_versions,
  update_buttons,
  get_func_update,
  get_func_detail,
} from "@/service/api/func_module";

// import func from '../../../../vue-temp/vue-editor-bridge';
export default {
  components: { addDialog },
  props: {
    client_type: {
      type: Array,
    },
    version_uuid: {
      type: String,
    },
    version_uuid123: {
      type: String,
    },
    module_uuid: {
      type: String,
    },
    list: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      dialogTitle: "",
      submitLoading: false,
      delDesserts: [],
      skLoading: true,
      dialogWidth: "600px",
      desserts: [],
      dialog: false,
      btnFunc: [], // 按钮功用
      btnType: [], // 按钮类型
      version_arr: [],
      dialogDefaultData: {},
      editedIndex: -1,
      onlyShow: false,
      update_add: false,
      disabled: false,
      func_version: "",
      files: [],
      deleteFiles: [],
    };
  },
  created() {},
  async mounted() {
    this.skLoading = true;
    try {
      this.func_version = this.version_uuid;
      const version_data = await getBusinessList({
        prompt_name: "function_button_version",
        module_uuid: this.module_uuid,
      });
      if (version_data.code == 200) {
        this.version_arr = version_data.data;
      } else {
        this.version_arr = [];
      }
      // 按钮类型普通参照
      const btnType = await getDataByName("buttonType");
      btnType.code == 200 ? (this.btnType = btnType.data) : (this.btnType = []);
      // 按钮功用 普通参照
      const btnFunc = await getDataByName("buttonUse");
      btnFunc.code == 200 ? (this.btnFunc = btnFunc.data) : (this.btnFunc = []);
      this.desserts = this.$clone(this.list);
      if (this.$store.state.uuid) {
        if (!this.$store.state.iconstatus) {
          this.disabled = true;
          this.$store.commit("set_iconstatus", false);
        }
      } else {
        this.disabled = !this.disabled;
      }
      this.skLoading = false;
    } catch (error) {
      this.skLoading = false;
    }
  },
  methods: {
    addBtnIcon(v, v2) {
      if (v) this.files.push(v);
      if (v2.uuid) this.deleteFiles.push(v2);
    },
    handleReturn() {
      this.$router.go(-1);
    },
    handleEdit() {
      this.disabled = !this.disabled;
      // const actions = {
      //   text: ' ',
      //   align: 'start',
      //   sortable: false,
      //   value: 'actions',
      //   width: '120px'
      // }
      // this.header.push(actions)
    },
    // 添加按钮
    async open_btn_dialog() {
      this.dialog = true;
      this.dialogTitle = this.$t("label_Add_a_button");
      this.onlyShow = false;
      // 就只有修改功能的地方  新增按钮才会修改版本 传个属性过去
      if (this.$store.state.uuid) {
        const version_data = await getBusinessList({
          prompt_name: "function_button_version",
          module_uuid: this.module_uuid,
        });
        if (version_data.code == 200) {
          this.version_arr = version_data.data;
        } else {
          this.version_arr = [];
        }
        this.update_add = true;
      } else {
        this.update_add = false;
      }
    },
    // 保存
    async getBtnDetail(obj) {
      if (this.editedIndex > -1) {
        // obj.execute = 2 // execute 1 增 2 改 3 删
        Object.assign(this.desserts[this.editedIndex], obj);
      } else {
        // obj.execute = 1
        this.$set(this.desserts, this.desserts.length, obj);
        // this.desserts.push(obj)
        // console.log(this.desserts)
      }
      // const update = await update_buttons(obj)
      // if (update.code == 200) {
      //
      //   this.disabled = !this.disabled
      // }
      this.dialogClose();
    },
    dialogClose() {
      this.dialog = false;
      this.editedIndex = -1;
      this.dialog = false;
      this.update_add = false;
    },
    // 取消 上一步
    cancel() {
      if (this.$store.state.uuid) {
        this.disabled = !this.disabled;
        // this.header.pop()
      } else {
        this.$emit("cancel");
      }
    },
    // 提交按钮
    async success() {
      // 新增 功能按钮提交this.$store.state.uuid
      const hasClient = this.desserts.every((item) => {
        return item.client_type_uuid != "";
      });
      if (!hasClient) {
        this.$Message({ text: this.$t("message_Function_client") });
        return;
      }
      if (!this.$store.state.uuid) {
        // 新增按钮提交
        this.$emit("success", this.desserts, this.files, this.deleteFiles);
      } else {
        let urllist = []; //上传图片url集合
        Promise.all(
          this.files.map((item) => {
            //上传图片
            return new Promise((resolve, reject) => {
              this.$uploadFiles(item.file, {
          module_uuid:'module',
          function_uuid: this.$store.state.menuFunctionUuid,
              })
                .then((res) => {
                  if (
                    typeof res == "object" &&
                    res != undefined &&
                    res.code == 200
                  ) {
                    this.desserts.forEach((item1) => {
                      if (item1.uuid == item.uuid) {
                        item1.button_icon = res.uuid;
                      }
                    });
                    urllist = res.uuid;
                  }
                  resolve(res);
                })
                .catch((err) => {
                  reject(err);
                });
            });
          })
        ).then(async (res) => {
          let arr = this.$clone(this.desserts);
          arr = arr.concat(this.delDesserts);
          arr.forEach((item) => {
            if (item.button_id) {
              delete item.button_id;
            }
          });
          this.submitLoading = true;
          const update = await update_buttons({
            uuid: this.$store.state.uuid,
            function_name: this.$route.meta.title,
            mrbase_sys_function_buttons: arr,
            // created_utc_datetime: 1
          });
          if (update.code == 200) {
            this.deleteFiles.forEach((item) => {
              this.$deleteFile(item.uuid);
            });
            this.$Message({
              text: this.$t("message_The_submission_was_successful"),
            });
            this.header.pop();
            this.disabled = !this.disabled;
            this.delDesserts = [];
            // 调详情接口，更新按钮列表
            const res1 = await get_func_detail({
              uuid: this.$store.state.uuid,
            });
            this.desserts = res1.mrbase_sys_function_buttons;
            // this.$router.go(-1)
          } else {
            this.$deleteFile(urllist);
          }
          this.submitLoading = false;
        });
      }
    },
    changeItem(item, onlyShow) {
      this.onlyShow = onlyShow;
      if (this.$store.state.uuid) {
        this.update_add = true;
        // item.execute = 1
      } else {
        this.update_add = false;
        // item.execute = 2
      }
      // 打开弹窗的时候会用这条数据的版本获取版本列表
      getBusinessList({
        prompt_name: "function_button_version",
        module_uuid: this.module_uuid,
        version_uuid: item.version_uuid,
      }).then((res) => {
        if (res.code == 200) {
          this.version_arr = res.data;
        } else {
          this.version_arr = [];
        }
      });

      this.editedIndex = this.desserts.indexOf(item);
      this.dialogDefaultData = this.$clone(item);
      this.dialogTitle = this.dialogDefaultData.button_name;
      this.dialog = true;
    },
    delItem(item) {
      // if (item.button_type == 1) {
      //
      //   return
      // }
      const index = this.desserts.indexOf(item);
      // confirm('Are you sure you want to delete this item?') && this.desserts.splice(index, 1)
      if (item.uuid) {
        // item.execute = 3
        item["~type~"] = "del";
        this.delDesserts.push(item);
      }
      this.desserts.splice(index, 1);
    },
    // 升级版本
    async upItem(item) {
      const index = this.desserts.indexOf(item);
      const up = await up_versions({ uuid: item.uuid });
      if (up.code == 200) {
        this.$Message({ text: this.$t("message_update_successed") });
        // this.disabled = !this.disabled
        // this.header.pop()
        item.version = up.data.version;
        this.$set(this.desserts, index, item);
        this.func_version = up.data.version_uuid;
      }
    },
  },
  computed: {
    btnTypeToName(val) {
      return (val) => {
        let name = "";
        this.btnType.forEach((item) => {
          if (item.dict_value == val) {
            name = item.dict_label;
          }
        });
        return name;
      };
    },
    header() {
      const arr = [
        {
          text: this.$t("label_type"),
          align: "start",
          sortable: false,
          value: "button_type",
        },
        {
          text: this.$t("label_The_name_of_the_button"),
          align: "start",
          sortable: false,
          value: "button_name",
        },
        {
          text: this.$t("label_Client_type"),
          align: "start",
          sortable: false,
          value: "client_type_uuid",
        },
        {
          text: this.$t("label_The_title"),
          align: "start",
          sortable: false,
          value: "button_title",
        },
        {
          text: this.$t("label_URL"),
          align: "start",
          sortable: false,
          value: "url",
        },
        {
          text: this.$t("label_state"),
          align: "start",
          sortable: false,
          value: "status_uuid",
        },
        {
          text: " ",
          align: "end",
          sortable: false,
          value: "actions",
          width: "120px",
        },
      ];
      return arr;
    },
  },
  watch: {
    // disabled: {
    //   handler (v) {
    //     if (!this.$store.state.uuid) return
    //     if (!v) {
    //       this.$route.meta.title = 'label_edit_module_functions'
    //       this.$store.commit('set_page_title', 'label_edit_module_functions')
    //     }
    //     else {
    //       this.$route.meta.title = 'label_view_module_functions'
    //       this.$store.commit('set_page_title', 'label_view_module_functions')
    //     }
    //   }, immediate: true
    // },
    // async version_uuid(val) {
    //   if (this.$store.state.uuid) {
    //     const version_data = await get_versions({
    //       version: val,
    //       module_uuid: this.module_uuid,
    //     })
    //     this.version_arr = version_data.data.version.split(',')
    //   } else {
    //     this.func_version = val
    //     // 新增功能的时候新增按钮 按钮的版本和功能的版本一致
    //     this.desserts.length > 0 &&
    //       this.desserts.forEach((item) => {
    //         item.version = val
    //       })
    //   }
    // },
    list: {
      handler(val) {
        this.delDesserts = [];
        this.desserts = val;
      },
      deep: true,
    },
    dialog(val) {
      if (!val) {
        this.dialogDefaultData = {};
      }
    },
    async module_uuid(val) {
      const version_data = await getBusinessList({
        prompt_name: "function_button_version",
        module_uuid: val,
      });
      if (version_data.code == 200) {
        this.version_arr = version_data.data;
        this.desserts.forEach((i) => {
          i.version_uuid = this.version_arr[0].value_field;
        });
      } else {
        this.version_arr = [];
      }
    },
    client_type: {
      handler(val, old) {
        // const ischange = val.map(item => {
        //   return old.every(i => {
        //     return item.value_field == i.value_field
        //   })
        // })
        // 客户端有变化那按钮就直接用功能的客户端
        this.desserts.forEach((i) => {
          i.client_type_uuid = "";
          val.forEach((j, index) => {
            i.client_type_uuid +=
              j.value_field + (index < val.length - 1 ? "," : "");
          });
        });
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.tableBoxComponent
  /deep/
  .v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr
  > td {
  padding: 8px 16px;
}
</style>
